import { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { changetimezone, listoftimezones } from "src/context/actions/auth/password/Password";
import Select from 'react-select';
import ReactiveButton from "reactive-button";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { ToastContainer } from 'react-toastify';

import Swal from "sweetalert2";

// const timezoneData = [
//     { id: 10, timezone_display: "Australia/Melbourne" },
//     { id: 9, timezone_display: "Asia/Dubai" },
//     { id: 8, timezone_display: "America/St_Johns" },
//     { id: 7, timezone_display: "America/Santiago" },
//     { id: 6, timezone_display: "America/Mexico_City" },
//     { id: 5, timezone_display: "America/Chicago" },
//     { id: 4, timezone_display: "Asia/Kolkata" },
//     { id: 3, timezone_display: "America/Los_Angeles" },
//     { id: 2, timezone_display: "America/New_York" },
//     { id: 1, timezone_display: "UTC" }
// ];

const Timezone = () => {
    const [timeZoneIsOpen, setTimeZoneIsOpen] = useState(false);
    const [timeZoneLabel, setTimeZoneLabel] = useState(null);
    const [showToastMessage, setShowToastMessage] = useState({
        status: false,
        message: '',
        type: '',
    })
    const [selectedTimezoneOptions, setSelectedTimezoneOptions] = useState([]);

    const formik = useFormik({
        initialValues: {
            timezone: ""
        },
        validationSchema: Yup.object().shape({
            timezone: Yup.object().shape({
                value: Yup.string().required("Required"),
                label: Yup.string().required("Required")
            })
        }),
        onSubmit: (values) => {
            showalert();
            closeModal()
        }
    });

    const showalert = () => {
        Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#6ba2b6",
            denyButtonColor: "#575757",
             confirmButtonColor: "rgb(27, 161, 166)",
            showDenyButton: true,
            customClass: {
                popup: 'small-alert'
            }
        })
        .then((result) => {
            if (result?.isConfirmed || result?.isDenied) {

                changetimezone(formik?.values?.timezone?.value)(response => {
                    setTimeZoneIsOpen(false);
                    setShowToastMessage({
                        status: true,
                        message: 'Success',
                        type: 'success'

                    })

                    localStorage.setItem("selectedTimezone", JSON.stringify({
                        value: formik?.values?.timezone?.value, 
                        label: formik?.values?.timezone?.label
                    }));

                    setTimeZoneLabel(formik?.values?.timezone?.label);
                    
                    window.location.reload()
                });
            } else {
                setTimeZoneIsOpen(false);
            }
        });
    };

    const handleSelectChange = (event) => {
        formik.setValues({
            ...formik.values,
            timezone: { value: event.value, label: event.label }
        });
    };

    useEffect(() => {
        const savedTimezone = JSON.parse(localStorage.getItem("selectedTimezone"));
    
        if (savedTimezone) {
            setTimeZoneLabel(savedTimezone.label); 
            formik.setFieldValue("timezone", savedTimezone);  
        }
    
        listoftimezones()((response) => {
            const timezoneOptions = response?.data?.results?.map(item => ({
        //    timezoneData
        
                value: item.id,
                label: item.timezone_display
            }));

            setSelectedTimezoneOptions(timezoneOptions);
        });
    }, []);
    

    const closeModal = () => setTimeZoneIsOpen(false);

    return (
        <div>
            <div className='me-3'>
                <p 
                    onClick={() => setTimeZoneIsOpen(true)} 
                    className='fw-bolder timezone_custom ' 
                    style={{ color: "#198754", cursor: 'pointer',marginBottom: 0, padding: 0 }}
                >
                    {timeZoneLabel || "UTC(UTC+00:00)"}
                </p>
            </div>
            <Modal show={timeZoneIsOpen} onHide={closeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='fw-bold clr-heading fs-5'>Change Timezone</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className='input-group d-flex flex-row justify-content-center align-items-center pt-2'>
                            <Select
                                className="basic-single select-search timeZone-select"
                                classNamePrefix="select"
                                value={formik?.values?.timezone}
                                onChange={handleSelectChange}
                                name="timeZone"
                                options={selectedTimezoneOptions}
                                placeholder={"Select Timezone"}
                                styles={{
                                    control: (base) => ({ ...base, minWidth: "250px" }),
                                    menu: (base) => ({ ...base, minWidth: "250px" })
                                }}
                            />
                        </div>
                        <div className='my-2'>
                            <div className='d-flex flex-row justify-content-center align-items-center pt-2'>
                                <ReactiveButton
                                    type={'button'}
                                    onClick={formik.handleSubmit}
                                    idleText="Change"
                                    loadingText="Loading"
                                    successText="Done"
                                    style={{ backgroundColor: "rgb(27, 161, 166)" }}
                                    disabled={false}
                                    className='login-save-button'
                                />
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Timezone;
